import { useEffect, useState } from 'react';

import { loadProfile } from '../../store/profileSlice';

import ChangePasswordForm from './ChangePasswordForm';
import ProfileEditForm from './ProfileEditForm';

import { Box } from '@components/Box';
import { useAppDispatch, useAppSelector } from '@store/hooks';

const ProfileView: React.FC = () => {
  const dispatch = useAppDispatch();
  const { profile, isLoading, error } = useAppSelector(
    (s) => s.settingsProfile
  );
  const [showEdit, setShowEdit] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);

  useEffect(() => {
    dispatch(loadProfile());
  }, [dispatch]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center p-8">
        <span className="text-sm text-gray-500">Loading profile...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-4 text-sm text-red-600 bg-red-50 rounded-md">
        {error}
      </div>
    );
  }

  if (!profile) return null;

  if (showEdit) {
    return <ProfileEditForm onCancel={() => setShowEdit(false)} />;
  }

  if (showChangePassword) {
    return <ChangePasswordForm onCancel={() => setShowChangePassword(false)} />;
  }

  return (
    <Box>
      <div className="flex flex-col space-y-4 p-4">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-gray-900">Profile</h3>
          <button
            type="button"
            className="text-sm text-primary-600 hover:text-primary-800 font-medium"
            onClick={() => setShowEdit(true)}
          >
            Edit
          </button>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div>
            <p className="text-xs text-gray-500 uppercase tracking-wide">
              Display Name
            </p>
            <p className="text-sm text-gray-900 mt-0.5">
              {profile.displayName}
            </p>
          </div>
          <div>
            <p className="text-xs text-gray-500 uppercase tracking-wide">
              Email
            </p>
            <p className="text-sm text-gray-900 mt-0.5">{profile.email}</p>
          </div>
          <div>
            <p className="text-xs text-gray-500 uppercase tracking-wide">
              First Name
            </p>
            <p className="text-sm text-gray-900 mt-0.5">{profile.firstName}</p>
          </div>
          <div>
            <p className="text-xs text-gray-500 uppercase tracking-wide">
              Last Name
            </p>
            <p className="text-sm text-gray-900 mt-0.5">{profile.lastName}</p>
          </div>
          {profile.middleName && (
            <div>
              <p className="text-xs text-gray-500 uppercase tracking-wide">
                Middle Name
              </p>
              <p className="text-sm text-gray-900 mt-0.5">
                {profile.middleName}
              </p>
            </div>
          )}
          {profile.phoneNumber && (
            <div>
              <p className="text-xs text-gray-500 uppercase tracking-wide">
                Phone
              </p>
              <p className="text-sm text-gray-900 mt-0.5">
                {profile.phoneNumber}
              </p>
            </div>
          )}
        </div>

        <div className="border-t border-gray-200 pt-4">
          <button
            type="button"
            className="text-sm text-primary-600 hover:text-primary-800 font-medium"
            onClick={() => setShowChangePassword(true)}
          >
            Change Password
          </button>
        </div>
      </div>
    </Box>
  );
};

export default ProfileView;
